<path
    d="M11.2534 3.46977C10.7503 2.41543 9.24954 2.41543 8.74644 3.46977L7.2025 6.70534L3.64819 7.17386C2.48999 7.32653 2.02622 8.75386 2.87349 9.55815L5.47359 12.0264L4.82085 15.5515C4.60814 16.7002 5.8223 17.5823 6.84904 17.0251L9.99993 15.3149L13.1508 17.0251C14.1776 17.5823 15.3917 16.7002 15.179 15.5515L14.5263 12.0264L17.1264 9.55815C17.9736 8.75386 17.5099 7.32653 16.3517 7.17386L12.7974 6.70534L11.2534 3.46977Z"
    fill="currentColor"
/>
